import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFreenasComponent } from './simple-icons-freenas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFreenasComponent ],
    exports:      [ SimpleIconsFreenasComponent ],
    bootstrap:    []
})
export class SimpleIconsFreenasModule {}
